/**
 * 文本阅读主题常量定义
 * 提供预设的文本阅读颜色主题，优化阅读体验
 */
/**
 * 预设的文本阅读主题集合
 * 包含多种适合长时间阅读的颜色搭配
 */
export const TEXT_READING_THEMES = [
    {
        id: 'default',
        name: 'Default',
        textColor: '#1f2937', // 深灰色文字 - gray-800
        backgroundColor: '#ffffff', // 纯白背景
    },
    {
        id: 'warm',
        name: 'Warm',
        textColor: '#374151', // 稍浅的深灰 - gray-700
        backgroundColor: '#fef7ed', // 暖米色背景 - orange-50
    },
    {
        id: 'soft',
        name: 'Soft',
        textColor: '#1f2937', // 深灰色文字 - gray-800
        backgroundColor: '#f9fafb', // 极浅灰背景 - gray-50
    },
    {
        id: 'night',
        name: 'Night',
        textColor: '#e5e7eb', // 浅灰文字 - gray-200
        backgroundColor: '#1f2937', // 深灰背景 - gray-800
    },
    {
        id: 'sepia',
        name: 'Sepia',
        textColor: '#451a03', // 深棕色文字 - amber-900
        backgroundColor: '#fef3c7', // 浅黄背景 - amber-100
    },
];
/**
 * 默认的文本阅读主题
 * 系统初始化时使用的默认主题
 */
export const DEFAULT_TEXT_READING_THEME = TEXT_READING_THEMES[0];
/**
 * 根据主题ID获取主题对象
 * @param themeId 主题ID
 * @returns 主题对象，如果未找到则返回默认主题
 */
export const getTextReadingThemeById = (themeId) => {
    return TEXT_READING_THEMES.find(theme => theme.id === themeId) || DEFAULT_TEXT_READING_THEME;
};
/**
 * 检查主题ID是否有效
 * @param themeId 主题ID
 * @returns 是否为有效的主题ID
 */
export const isValidTextReadingThemeId = (themeId) => {
    return TEXT_READING_THEMES.some(theme => theme.id === themeId);
};
//# sourceMappingURL=text-reading-themes.js.map